import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Loader2 } from "@/components/icons";
import { MpiresLogo } from "@/components/Brand";

const INPUT =
  "w-full h-11 px-3.5 rounded-lg border border-input bg-white text-sm outline-none focus:ring-2 focus:ring-brand/40 focus:border-brand transition";

export default function ForgotPassword() {
  const [step, setStep] = useState("request");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const request = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { phone: phone.trim() });
      toast.success("Se o telefone estiver cadastrado, enviaremos um código por SMS.");
      setStep("reset");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { phone: phone.trim(), code: code.trim(), new_password: newPassword });
      toast.success("Senha redefinida! Faça login.");
      window.location.href = "/login";
    } catch (err) {
      toast.error(errMsg(err, "Código inválido ou expirado"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md bg-card rounded-2xl border border-black/5 shadow-[0_10px_40px_rgb(0,0,0,0.06)] p-8">
        <div className="mb-6">
          <MpiresLogo height={144} />
        </div>
        {step === "request" ? (
          <form onSubmit={request} data-testid="forgot-form">
            <h2 className="text-2xl font-semibold text-navy">Recuperar senha</h2>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Informe o telefone cadastrado para receber o código por SMS.</p>
            <input required type="tel" placeholder="Telefone com DDD, ex: +55 11 99999-9999" value={phone} onChange={(e) => setPhone(e.target.value)} className={INPUT} data-testid="forgot-phone" inputMode="tel" />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full h-11 mt-6 rounded-lg bg-brand text-white font-semibold text-sm hover:bg-brand-hover transition-colors flex items-center justify-center disabled:opacity-60">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar código por SMS"}
            </button>
          </form>
        ) : (
          <form onSubmit={reset} data-testid="reset-form">
            <h2 className="text-2xl font-semibold text-navy">Nova senha</h2>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Digite o código recebido por SMS e a nova senha.</p>
            <div className="space-y-3">
              <input required placeholder="Código de 6 dígitos" maxLength={6} value={code} onChange={(e) => setCode(e.target.value)} className={INPUT} data-testid="reset-code" inputMode="numeric" />
              <input required type="password" placeholder="Nova senha" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className={INPUT} data-testid="reset-password" />
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full h-11 mt-6 rounded-lg bg-brand text-white font-semibold text-sm hover:bg-brand-hover transition-colors flex items-center justify-center disabled:opacity-60">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Redefinir senha"}
            </button>
          </form>
        )}
        <p className="text-center text-sm text-muted-foreground mt-6">
          <Link to="/login" className="text-brand font-semibold hover:text-brand-hover">Voltar para o login</Link>
        </p>
      </div>
    </div>
  );
}
